{
  "contractVersion": 1,
  "generatedAt": "2026-04-05T00:00:00.000Z",
  "season": { "id": "season-2026-q2", "name": "Season 2", "dayNumber": 5 },
  "sides": {
    "beornings": { "totalPoints": 1300, "sharePct": 68.4 },
    "lothwen": { "totalPoints": 600, "sharePct": 31.6 }
  },
  "world": { "treesChoppedTotal": 13, "treesPlantedTotal": 6 },
  "events": [
    { "id": 1, "type": "tree_felled", "side": "beornings", "at": "2026-03-01" },
    { "id": 2, "type": "tree_planted", "side": "lothwen", "at": "2026-03-02" },
    { "id": 3, "type": "tree_felled", "side": "beornings", "at": "2026-03-03" },
    { "id": 4, "type": "tree_planted", "side": "lothwen", "at": "2026-03-05" },
    { "id": 5, "type": "season_reset", "seasonId": "season-2026-q2", "at": "2026-04-01" },
    { "id": 6, "type": "tree_felled", "side": "beornings", "at": "2026-04-03" },
    { "id": 7, "type": "tree_planted", "side": "lothwen", "at": "2026-04-04" }
  ]
}
